<template>
  <div class="lg-page">
    <!-- Left brand panel -->
    <aside class="lg-hero">
      <span class="lg-blob lg-blob--1"></span>
      <span class="lg-blob lg-blob--2"></span>

      <div class="lg-hero__inner reveal" :class="{ 'reveal--visible': shown }">
        <h1 class="lg-hero__title">{{ lg_login.li_hero_title }}</h1>
        <p class="lg-hero__sub">{{ lg_login.li_hero_subtitle }}</p>

        <ul class="lg-feats">
          <li v-for="f in features" :key="f.key">
            <span class="lg-feats__icon"><v-icon small color="#ffffff">{{ f.icon }}</v-icon></span>
            {{ lg_login[f.key] }}
          </li>
        </ul>
      </div>

      <p class="lg-hero__copy">{{ lg_login.li_copyright }}</p>
    </aside>

    <!-- Right form panel -->
    <main class="lg-main">
      <form class="lg-form reveal" :class="{ 'reveal--visible': shown }" @submit.prevent="submit" novalidate>
        <h2 class="lg-form__title">{{ lg_login.li_title }}</h2>
        <p class="lg-form__sub">{{ lg_login.li_subtitle }}</p>

        <label class="lg-label" for="lg-email">{{ lg_login.email }}</label>
        <input
          id="lg-email"
          v-model="account.username"
          type="email"
          class="lg-input"
          :class="{ 'lg-input--error': errors.username }"
          :placeholder="lg_login.email_place"
          autocomplete="username"
        />
        <p v-if="errors.username" class="lg-err">{{ errors.username }}</p>

        <div class="lg-label-row">
          <label class="lg-label" for="lg-pass">{{ lg_login.password }}</label>
          <a href="#" class="lg-link-sm" @click.prevent="$router.push('/forgot-password')">{{ lg_login.btn_forgot }}</a>
        </div>
        <div class="lg-pass">
          <input
            id="lg-pass"
            v-model="account.password"
            :type="e1 ? 'password' : 'text'"
            class="lg-input"
            :class="{ 'lg-input--error': errors.password }"
            :placeholder="lg_login.password_place"
            autocomplete="current-password"
          />
          <button type="button" class="lg-eye" @click="e1 = !e1">
            <v-icon small color="#64748b">{{ e1 ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}</v-icon>
          </button>
        </div>
        <p v-if="errors.password" class="lg-err">{{ errors.password }}</p>

        <label class="lg-check">
          <input v-model="checkrememberme" type="checkbox" />
          <span>{{ lg_login.remember_me }}</span>
        </label>

        <div v-if="$store.getters['altlogin']" class="lg-alert">
          <v-icon small color="#dc2626">mdi-alert-circle-outline</v-icon>
          {{ messageAlert }}
        </div>

        <button type="submit" class="lg-btn">{{ lg_login.btn_login }}</button>

        <p class="lg-register">
          {{ lg_login.li_no_account }}
          <!-- @click.prevent="$router.push('/register-account')" -->
          <a href="/register-account" >{{ lg_login.li_start_free }}</a>
        </p>
        <p class="lg-back">
          <a href="#" @click.prevent="$router.push('/')">&larr; {{ lg_login.li_back_home }}</a>
        </p>
      </form>
    </main>

    <LoadingDialog></LoadingDialog>
  </div>
</template>

<script lang="js">
import api from "@/services/api";
import LoadingDialog from "@/components/cards/LoadingDialog";
import { server } from "../services/constants";
import { feature } from "../services/constants";
import { lg_login } from "./language/lg_login.js";

export default {
  name: "login",
  props: [],
  components: {
    LoadingDialog,
  },
  created() {
    this.$store.state.page_reload = false;
    this.$store.state.altLogin = false;
  },
  mounted() {
    localStorage.setItem(server.MEET_STA, "false");
    if (api.isLoggedIn()) {
      this.$router.push("/");
    }
    this.$store.state.loadMenu = false;
    this.$store.state.meetSta = false;
    this.$store.state.navMenu = false;
    this.$store.state.loadFooter = false;

    this.timer = setTimeout(() => (this.shown = true), 150);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  beforeUnmount() {
    clearTimeout(this.timer);
  },
  data() {
    const lg =
      localStorage.getItem(feature.LANGUAGE) === "th" ? lg_login.login_th : lg_login.login_en;
    return {
      lg_login: lg,
      shown: false,
      timer: null,
      features: [
        { key: "li_feature1", icon: "mdi-video-outline" },
        { key: "li_feature2", icon: "mdi-shield-outline" },
        { key: "li_feature3", icon: "mdi-web" },
      ],
      checkrememberme: false,
      messageAlert: lg.messageAlert,
      account: {
        username: "",
        password: "",
      },
      errors: { username: "", password: "" },
      valid: false,
      e1: true,
      password: "",
      passwordRules: [(v) => !!v || "Please enter your password"],
      email: "",
      emailRules: [(v) => !!v || "Please enter your email address"],
    };
  },
  methods: {
    runRules(rules, value) {
      for (const r of rules) {
        const res = r(value);
        if (res !== true) return res;
      }
      return "";
    },
    validate() {
      this.errors.username = this.runRules(this.emailRules, this.account.username);
      this.errors.password = this.runRules(this.passwordRules, this.account.password);
      this.valid = !this.errors.username && !this.errors.password;
      return this.valid;
    },
    async submit() {
      if (this.validate()) {
        this.$store.state.loadMenu = true;
        this.$store
          .dispatch({
            type: "doLogin",
            username: this.account.username,
            password: this.account.password,
            rememberme: this.checkrememberme,
          })
          .then((data) => {
            this.$store.state.loadMenu = false;
            if (data == false) {
              this.$router.push("/login-account").catch(() => {});
            }
          });
      }
    },
    clear() {
      this.account.username = "";
      this.account.password = "";
      this.errors = { username: "", password: "" };
    },
  },
  watch: {
    "account.username"() {
      if (this.errors.username) this.errors.username = "";
    },
    "account.password"() {
      if (this.errors.password) this.errors.password = "";
    },
  },
};
</script>

<style scoped>
.lg-page {
  display: flex;
  /* height: calc(100vh - 70px); */
  height: calc(100dvh - 70px);
  overflow: hidden;
  background: #ffffff;
  font-family: inherit;
}
.lg-main {
  flex: 1 1 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  overflow-y: auto; /* scroll only when the screen is too short for the form */
}

/* ---------- Left ---------- */
.lg-hero {
  position: relative;
  flex: 1 1 50%;
  background: #215295;
  color: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px;
}
.lg-blob {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  pointer-events: none;
}
.lg-blob--1 { width: 620px; height: 620px; top: -270px; left: -140px; }
.lg-blob--2 { width: 720px; height: 720px; bottom: -300px; right: -240px; }

.lg-hero__inner { position: relative; max-width: 440px; }
.lg-hero__title {
  font-size: 36px;
  line-height: 1.3;
  font-weight: 700;
  white-space: pre-line;
  margin: 0 0 20px;
}
.lg-hero__sub {
  font-size: 17px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.85);
  margin: 0 0 36px;
}
.lg-feats { list-style: none; padding: 0; margin: 0; }
.lg-feats li {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  margin-bottom: 16px;
}
.lg-feats__icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.15);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.lg-hero__copy {
  position: absolute;
  left: 48px;
  bottom: 40px;
  margin: 0;
  font-size: 12px;
  color: #93c5fd;
}

.lg-form { width: 100%; max-width: 384px; }
.lg-form__title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px;
}
.lg-form__sub { font-size: 14px; color: #64748b; margin: 0 0 32px; }

.lg-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  margin-bottom: 8px;
}
.lg-label-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 20px;
}
.lg-link-sm { font-size: 12px; color: #215295; text-decoration: none; }
.lg-link-sm:hover { text-decoration: underline; }

.lg-input {
  width: 100%;
  height: 42px;
  padding: 0 14px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
  color: #0f172a;
  background: #ffffff;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.lg-input::placeholder { color: #94a3b8; }
.lg-input:focus { border-color: #215295; box-shadow: 0 0 0 3px rgba(33, 82, 149, 0.15); }
.lg-input--error { border-color: #dc2626; }
.lg-err { font-size: 12px; color: #dc2626; margin: 6px 0 0; }

.lg-pass { position: relative; }
.lg-pass .lg-input { padding-right: 42px; }
.lg-eye {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: 0;
  padding: 4px;
  cursor: pointer;
}

.lg-check {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 20px 0 22px;
  font-size: 14px;
  color: #334155;
  cursor: pointer;
}
.lg-check input { width: 16px; height: 16px; accent-color: #215295; cursor: pointer; }

.lg-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 16px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  border-radius: 8px;
  font-size: 13px;
  color: #dc2626;
}

.lg-btn {
  width: 100%;
  height: 40px;
  border: 0;
  border-radius: 8px;
  background: #215295;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.lg-btn:hover { background: #1a4278; }

.lg-register {
  text-align: center;
  font-size: 14px;
  color: #64748b;
  margin: 32px 0 0;
}
.lg-register a { color: #215295; font-weight: 600; text-decoration: none; }
.lg-register a:hover { text-decoration: underline; }
.lg-back { text-align: center; margin: 22px 0 0; }
.lg-back a { font-size: 12px; color: #94a3b8; text-decoration: none; }
.lg-back a:hover { color: #215295; }

/* ---------- Animation ---------- */
.reveal {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.7s ease, transform 0.7s ease;
}
.reveal--visible { opacity: 1; transform: translateY(0); }
@media (prefers-reduced-motion: reduce) {
  .reveal { opacity: 1; transform: none; transition: none; }
}

/* ---------- Responsive ---------- */
@media (max-width: 959px) {
  .lg-hero { display: none; }
  .lg-main {
    align-items: flex-start;
    /* padding: 32px 20px 24px; */
  }
   .lg-page { height: calc(100dvh - 120px);}
}
</style>